//import Cookies from 'universal-cookie';
import { 
    INICIO_SESION,
    INICIO_CONEXION,
    ERROR_CONEXION,
    DETENER_CONEXION,
    CIERRE_SESION,
    OBTENER_GUID,
    ERROR_GUID,
    VALIDAR_SESION,
    ERROR_CIERRE_SESSION
} from '../types';


/** Cada reducer debe tener su propio state */

const inicialState = {
    requests: 0,
    identity: null,
    guid: null,//localStorage.getItem('crolSession'),
    error: null,
    guidValidated: false,
    cerrarSesion: false,
    firmarAppCrol: false,
}

//const cookies = new Cookies();

export default function(state = inicialState, action) {
    switch(action.type) {
        case ERROR_CONEXION:
            return {
                ...state,
                error: action.payload
            };
        case INICIO_CONEXION:
            return {
                ...state,
                requests: state.requests + 1
            };
        case DETENER_CONEXION:
            return {
                ...state,
                requests: state.requests - 1,
                guid: null
            };
        case INICIO_SESION:
            return {
                ...state,
                identity: action.payload
            };
        case CIERRE_SESION:
            localStorage.removeItem('crolSession');
            //cookies.remove('crolGUID', { path: '/' });
            //cookies.remove('crolGUID', { path: '/CrolLogin' });
            return {
                ...state,
                identity: null,
                guid: null,
                error: null,
                cerrarSesion: false
            };
        case OBTENER_GUID:
            localStorage.setItem('crolSession',action.payload);
            //cookies.set('crolGUID', `${action.payload}`);
            return {
                ...state,
                requests: 0,
                guid: action.payload,
            };
        case ERROR_GUID:
            localStorage.removeItem('crolSession');
            //cookies.remove('crolGUID', { path: '/' });
            //cookies.remove('crolGUID', { path: '/CrolLogin' });
            return {
                ...state,
                requests: 0,
                guid: null,
                error: action.payload,
                guidValidated: false,
                cerrarSesion: (action.payload === 'salir') ? true : false
            };
        case VALIDAR_SESION:
            localStorage.setItem('crolSession',action.payload.GUID);
            //cookies.set('crolGUID', `${action.payload}`);
            return {
                ...state,
                requests: 0,
                guid: action.payload.GUID,
                firmarAppCrol: action.payload.firmarAppCrol,
                guidValidated: true
            };
        case ERROR_CIERRE_SESSION:
            return {
                ...state,
                requests: 0,
                error: action.payload,
                identity: null,
                guid: null
            }
        default:
            return state;
    }
}